module.exports = __webpack_public_path__ + "static/assets/00b70b68a9912daf6df4e2799967535f.svg";